import React, { useState } from "react";

const LinkGenerator = () => {
  const [name, setName] = useState("");
  const [link, setLink] = useState("");

  const handleGenerate = () => {
    if (!name.trim()) return alert("Please enter a name");
    const encoded = encodeURIComponent(name.trim());
    const inviteLink = `https://sn-the-wedding.vercel.app/${encoded}`;
    setLink(inviteLink);
  };

  return (
    <div style={{ 
      fontFamily: "Battambang, sans-serif", 
      textAlign: "center", 
      marginTop: "100px" 
    }}>
      <h2>🔗 កម្មវិធីបង្កើតតំណភ្ញៀ វ </h2>
      <h2>(Guest Link Generator)</h2>
      <p>សូមបញ្ចូលឈ្មោះភ្ញៀ វរបស់អ្នក (អាចប្រើអក្សរខ្មែរ ឬអង់គ្លេស)</p>

      <input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder="ឧទាហរណ៍៖ លោក ទេព សត្យា"
        style={{
          padding: "10px 15px",
          fontSize: "16px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          width: "80%",
          maxWidth: "400px",
          marginTop: "20px"
        }}
      />

      <div>
        <button
          onClick={handleGenerate}
          style={{
            marginTop: "20px",
            padding: "10px 20px",
            borderRadius: "8px",
            border: "none",
            backgroundColor: "#3c5700",
            color: "white",
            cursor: "pointer"
          }}
        >
          បង្កើតតំណ (Generate Link)
        </button>
      </div>

      {link && (
        <div style={{ marginTop: "30px" }}>
          <p>តំណសម្រាប់ចែករំលែក:</p>
          <a 
            href={link} 
            target="_blank" 
            rel="noopener noreferrer"
            style={{ color: "#867222", wordBreak: "break-all" }}
          >
            {link}
          </a>
        </div>
      )}
    </div>
  );
};

export default LinkGenerator;
